// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link[data-v-55187fd2]{color:var(--btn-color);display:block;text-align:center;width:100%}.login[data-v-55187fd2]{height:auto;width:100%}.login-center[data-v-55187fd2]{max-width:400px;width:100%}.error[data-v-55187fd2]{background-color:#eb3d00;border-radius:10px;color:#fff;margin:10px;padding:20px}@media(min-width:576px){.login[data-v-55187fd2]{height:600px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
